import partNumber from './partNumber'
import manufacturer from './manufacturer'
import category from './category'
import catClass from './catClass'
import classification from './classification'
import description from './description'
import listPrice from './listPrice'
import msrp from './msrp'
import getActions from './actions'
import { Part } from '../../../../graphql'

export default function getColumns(
	canEdit: boolean,
	openEditModal: ( part: Part ) => void,
) {
	return [
		partNumber,
		manufacturer,
		description,
		catClass,
		category,
		classification,
		listPrice,
		msrp,
		getActions( canEdit, openEditModal ),
	]
}
